/**
 * Pavillion Theme Overrides
 * Client-specific design tokens for Pavillion energy company
 */

import type { ClientThemeOverrides } from '../utils/themeAugmentation';
import logo from '../../../themes/default/default.png';

export const pavillionThemeOverrides: ClientThemeOverrides = {
  clientId: 'pavillion',
  logo,
  clientName: 'Pavillion',
  palette: {
    light: {
      primary: {
        main: '#3bb375',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#505050',
        contrastText: '#ffffff',
      },
      info: {
        main: '#ffee58',
      },
      error: {
        main: '#ac1900',
      },
      atlas: {
        navigation: {
          background: '#1A3E35',
          secondaryBackground: '#3bb375',
          text: '#FFFFFF',
          textInactive: 'rgba(255, 255, 255, 0.7)',
          activeIndicator: '#FFCC33',
          ghostButtonBorder: 'rgba(255, 255, 255, 0.3)',
        },
      },
    },
    dark: {
      primary: {
        main: '#5bcf93',
        contrastText: '#000000',
      },
      secondary: {
        main: '#808080',
        contrastText: '#ffffff',
      },
      background: {
        default: '#121212',
        paper: '#1E1E1E',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.87)',
        secondary: 'rgba(255, 255, 255, 0.6)',
      },
      info: {
        main: '#ffee58',
      },
      error: {
        main: '#e53935',
      },
      atlas: {
        navigation: {
          background: '#1A3E35',
          secondaryBackground: '#2f8f5e',
          text: '#FFFFFF',
          textInactive: 'rgba(255, 255, 255, 0.7)',
          activeIndicator: '#FFCC33',
          ghostButtonBorder: 'rgba(255, 255, 255, 0.3)',
        },
      },
    },
  },
  typography: {
    fontSize: 12,
    h1: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '1.2rem',
      fontWeight: 400,
    },
    h5: {
      fontSize: '1.1rem',
      fontWeight: 400,
      color: '#3bb375',
    },
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          '&.noPadding': {
            padding: '0px !important',
            height: '100%',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          '&.flat': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            '& .MuiCardActions-root': {
              justifyContent: 'flex-end',
            },
          },
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          '&.noPadding': {
            padding: '0px !important',
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h1: {
          fontSize: '1.5rem',
          fontWeight: 500,
        },
        h2: {
          fontSize: '1.2rem',
          fontWeight: 400,
        },
        h5: {
          fontSize: '1.1rem',
          fontWeight: 400,
          color: '#3bb375',
        },
      },
    },
  },
  dataGrid: {
    highlightedCell: {
      backgroundColor: '#e1001aaf',
      textColor: '#ffffff',
    },
  },
};
